import React from 'react'
import PropTypes from 'prop-types'
import theme from 'styles/theme'
import IconWrapper from './IconWrapper'

const WeiboIcon = ({ color, width, height, display }) => (
  <IconWrapper width={width} height={height} display={display}>
    <svg width={width} height={height} viewBox="0 0 40 40">
      <g transform="translate(2 2)" fill="none" fillRule="evenodd">
        <circle
          stroke={theme.colors.sagelight}
          strokeLinecap="square"
          cx="18"
          cy="18"
          r="18"
        />
        <path
          d="M24.243 18.24c.323.213.603.512.842.897.238.384.357.811.357 1.28 0 .498-.13 1.01-.39 1.533-.259.524-.64 1.026-1.146 1.506-.505.48-1.096.91-1.772 1.291-.677.381-1.47.685-2.378.912-.908.228-1.856.341-2.845.341-.99 0-1.953-.123-2.893-.368a10.016 10.016 0 0 1-2.53-1.022 5.486 5.486 0 0 1-1.804-1.66A3.821 3.821 0 0 1 9 20.758c0-.843.244-1.74.731-2.693.487-.953 1.18-1.898 2.078-2.835 1.185-1.239 2.382-2.103 3.592-2.594 1.21-.491 2.074-.466 2.593.077.456.469.526 1.234.21 2.297-.027.102-.031.175-.01.22.021.043.056.069.105.076a.43.43 0 0 0 .153-.005c.052-.011.1-.024.142-.039l.063-.022c.974-.432 1.837-.648 2.587-.648.751 0 1.287.223 1.61.67.316.462.316 1.114 0 1.956-.014.096-.03.169-.047.22-.018.051-.002.097.047.138.05.04.091.067.126.082s.095.037.18.066c.4.132.76.304 1.083.517zm-3.435 5.04c1.028-.868 1.492-1.837 1.394-2.907-.063-.703-.375-1.326-.936-1.868-.561-.543-1.292-.942-2.193-1.198-.901-.257-1.864-.334-2.888-.231-1.564.168-2.86.687-3.887 1.555-1.027.868-1.492 1.837-1.394 2.907.063.703.375 1.326.936 1.869.561.542 1.293.941 2.194 1.198.9.256 1.864.333 2.887.23 1.564-.168 2.86-.686 3.887-1.555zm-3.57-4.411c.806.207 1.382.634 1.727 1.281.345.647.354 1.328.027 2.043-.327.729-.9 1.265-1.721 1.608-.82.343-1.634.386-2.44.129-.778-.243-1.313-.695-1.608-1.357-.294-.66-.27-1.331.071-2.01.342-.665.892-1.161 1.65-1.49.76-.329 1.524-.397 2.294-.204zm-1.166 3.474c.153-.243.193-.49.12-.74a.806.806 0 0 0-.49-.536 1.125 1.125 0 0 0-.796-.01 1.193 1.193 0 0 0-.653.493c-.16.243-.207.487-.142.734a.805.805 0 0 0 .469.541c.246.115.517.124.811.027.295-.096.522-.266.681-.509zm1.024-1.298a.32.32 0 0 0 .039-.284.308.308 0 0 0-.191-.198.443.443 0 0 0-.31.005.427.427 0 0 0-.235.199c-.123.221-.076.382.142.482a.459.459 0 0 0 .316-.005.426.426 0 0 0 .24-.199zm7.14-4.927a.695.695 0 0 1-.04-.494c.135-.466.054-.877-.242-1.232s-.656-.485-1.08-.389a.556.556 0 0 1-.454-.089.58.58 0 0 1-.252-.41.698.698 0 0 1 .08-.495.564.564 0 0 1 .374-.283 2.11 2.11 0 0 1 1.2.061c.398.137.738.38 1.02.728.283.348.466.75.55 1.204.084.456.062.89-.065 1.305a.633.633 0 0 1-.298.378.533.533 0 0 1-.45.044.61.61 0 0 1-.342-.328zm3.659-2.012c.177.914.13 1.785-.141 2.616a.725.725 0 0 1-.356.433.652.652 0 0 1-.543.043.712.712 0 0 1-.418-.368.753.753 0 0 1-.053-.563c.196-.592.23-1.213.105-1.863a3.569 3.569 0 0 0-.836-1.711 3.381 3.381 0 0 0-1.547-1.034 3.463 3.463 0 0 0-1.809-.092.675.675 0 0 1-.543-.103.719.719 0 0 1-.313-.471.726.726 0 0 1 .099-.558.7.7 0 0 1 .455-.32 4.823 4.823 0 0 1 2.55.125c.843.27 1.568.756 2.174 1.457a5.067 5.067 0 0 1 1.176 2.41z"
          fill={color}
        />
      </g>
    </svg>
  </IconWrapper>
)

WeiboIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  display: PropTypes.string,
}

WeiboIcon.defaultProps = {
  color: theme.colors.coaldark,
  width: '40px',
  height: '40px',
  display: 'inline-block',
}

export default WeiboIcon
